import { useEffect, useState } from "react";

// Hooks
import iconCamera from "../../../assets/images/camera.svg";
import keyboardIcon from "../../../assets/images/keyboard.svg";
import iconMicrophone from "../../../assets/images/mic.svg";
import iconMouseLeftClick from "../../../assets/images/mouse-left-click.svg";
import iconMouseRightClick from "../../../assets/images/mouse-right-click.svg";
import mouseIcon from "../../../assets/images/mouse.svg";
import { useGlobal } from "../../../contexts/globalContext";
import { useScreenIO } from "../../../contexts/screenIO/joinedMeetingScreenIOContext";

// SVGs

export default function IOInputs() {
  return (
    <div className="controler-items">
      <div className="controler-items-contaner">
        <MouseButton />
        <KeyboardButton />

        <div className="divider" />
        {/* Camera State Icons */}
        <div className="mouse-section">
          <img src={iconMicrophone} className="btn-32 btn-mic disable" />
        </div>
        {/* Microphone State Icons */}
        <div className="mouse-section">
          <img src={iconCamera} className="btn-32 btn-camera disable" />
        </div>
      </div>
    </div>
  );
}

function MouseButton() {
  const { SCREEN_STATE } = useGlobal();
  const { backendReportingMouseControls, userHasRequestedMouse, userHasMouse, lastSentMouseCommand, requestMouseControl, releaseMouseControl } =
    useScreenIO();

  const [connectedMouseState, setConnectedMouseState] = useState(); // ready for commands
  const [lastTimer, setLastTimer] = useState();

  useEffect(() => {
    if (!lastSentMouseCommand) return;
    setConnectedMouseState(lastSentMouseCommand.command);

    if (lastTimer) clearTimeout(lastTimer);

    const timer = setTimeout(() => {
      setConnectedMouseState();
    }, 500);

    setLastTimer(timer);
  }, [lastSentMouseCommand]);

  let buttonState = "inactive"; // not used as a valid state
  if (!userHasMouse) {
    if (!userHasRequestedMouse) {
      buttonState = "disable";
    } else {
      buttonState = "waiting-for-access";
    }
  } else if (!connectedMouseState) {
    // means ready for commands
    buttonState = "ready";
  } else if (connectedMouseState === "connected") {
    buttonState = "access-granted";
  } else if (connectedMouseState === "left-click") {
    buttonState = "left-click";
  } else if (connectedMouseState === "right-click") buttonState = "right-click";

  return (
    <>
      {/* TODO: following is mouse icon disabled (not clickable and not connected) state. use when participant is not allowed to ask for mouse control? */}
      <div className="mouse-section" style={buttonState !== "inactive" ? { display: "none" } : {}}>
        <img src={mouseIcon} className="btn-32 btn-mouse inactive" />
      </div>

      <div className="mouse-section" style={buttonState !== "disable" ? { display: "none" } : {}} onClick={requestMouseControl}>
        <img src={mouseIcon} className="btn-32 btn-mouse disable" />
      </div>

      <div className="mouse-section" style={buttonState !== "waiting-for-access" ? { display: "none" } : {}} onClick={releaseMouseControl}>
        <img src={mouseIcon} className="btn-32 btn-mouse changing-access" />
        <span className="waiting-for-access" />
        <div className="tooltip">Requested Mouse</div>
      </div>

      <div className="mouse-section" style={buttonState !== "ready" ? { display: "none" } : {}} onClick={releaseMouseControl}>
        <img src={mouseIcon} className="btn-32 btn-mouse active" />
      </div>

      <div className="mouse-section" style={buttonState !== "access-granted" ? { display: "none" } : {}}>
        <img src={mouseIcon} className="btn-32 btn-mouse changing-access" />
        <span className="access-granted" />
      </div>

      {/*
        // TODO: moving mouse state needs to be handled differently, since it should not override click states, and they could happen at the same time.
        // also moving styles are same as active state now.
        <div className="mouse-section" style={buttonState !== "moving" ? {display: 'none'} : {}}>
          <img src={iconMouseMove} className="btn-32" />
        </div>
      */}

      <div className="mouse-section" style={buttonState !== "left-click" ? { display: "none" } : {}}>
        <img src={iconMouseLeftClick} className="btn-32" />
      </div>

      <div className="mouse-section" style={buttonState !== "right-click" ? { display: "none" } : {}}>
        <img src={iconMouseRightClick} className="btn-32" />
      </div>

      <div style={{ color: "yellow", position: "absolute", pointerEvents: "none" }}>
        {backendReportingMouseControls[SCREEN_STATE.currentScreen.id] || 0}
      </div>
    </>
  );
}

function KeyboardButton() {
  const { SCREEN_STATE } = useGlobal();
  const {
    backendReportingKeyboardControls,
    userHasRequestedKeyboard,
    userHasKeyboard,
    lastSentKeyboardCommand,
    requestKeyboardControl,
    releaseKeyboardControl,
  } = useScreenIO();

  const [connectedKeyboardState, setConnectedKeyboardState] = useState(); // ready for commands
  const [lastTimer, setLastTimer] = useState();

  useEffect(() => {
    if (!lastSentKeyboardCommand) return;
    setConnectedKeyboardState(lastSentKeyboardCommand.command);

    if (lastTimer) clearTimeout(lastTimer);

    const timer = setTimeout(() => {
      setConnectedKeyboardState();
    }, 500);

    setLastTimer(timer);
  }, [lastSentKeyboardCommand]);

  let buttonState = "disabled"; // not used as a valid state yet
  if (!userHasKeyboard) {
    if (!userHasRequestedKeyboard) {
      buttonState = "inactive";
    } else {
      buttonState = "waiting-for-access";
    }
  } else if (!connectedKeyboardState) {
    // means ready for commands
    buttonState = "ready";
  } else if (connectedKeyboardState === "connected") {
    buttonState = "access-granted";
  } else if (connectedKeyboardState === "key-press") buttonState = "key-press";

  return (
    <>
      <div className="keybord-section" style={buttonState !== "disabled" ? { display: "none" } : {}}>
        <img src={keyboardIcon} className="btn-32 btn-keyboard disabled" />
      </div>

      <div className="keybord-section" onClick={requestKeyboardControl} style={buttonState !== "inactive" ? { display: "none" } : {}}>
        <img src={keyboardIcon} className="btn-32 btn-keyboard inactive" />
      </div>

      <div className="keybord-section" onClick={releaseKeyboardControl} style={buttonState !== "waiting-for-access" ? { display: "none" } : {}}>
        <img src={keyboardIcon} className="btn-32 btn-keyboard changing-access" />
        <span className="waiting-for-access" />
        <div className="tooltip">Requested Keyboard</div>
      </div>

      <div className="keybord-section" onClick={releaseKeyboardControl} style={buttonState !== "ready" ? { display: "none" } : {}}>
        <img src={keyboardIcon} className="btn-32 btn-keyboard ready" />
      </div>

      <div className="keybord-section" style={buttonState !== "access-granted" ? { display: "none" } : {}}>
        <img src={keyboardIcon} className="btn-32 btn-keyboard changing-access" />
        <span className="access-granted" />
      </div>

      <div className="keybord-section" style={buttonState !== "key-press" ? { display: "none" } : {}}>
        <img src={keyboardIcon} className="btn-32 btn-keyboard active" />
      </div>

      <div
        style={{
          color: "yellow",
          position: "absolute",
          pointerEvents: "none",
          transform: "translateX(42px)",
        }}>
        {backendReportingKeyboardControls[SCREEN_STATE.currentScreen.id] || 0}
      </div>
    </>
  );
}
